<template>
  <div class="sql-instanceUser-page">
    <Drawer
      :title="addPrivModalTitle"
      v-model="addPrivModal"
      width="992"
      :mask-closable="true"
      @on-close="addPrivCancel">
      <div>
        <Form ref="addPrivForm" :model="addPrivForm" :label-width="80">
          <FormItem label="服务器角色" prop="serverRoles">
            <transfer
              :data="serverRoleList"
              :target-keys="addPrivForm.serverRole"
              :list-style="listStyle"
              @on-change="addPrivServerRoleChange"
              filterable></transfer>
          </FormItem>
          <FormItem label="数据库角色" prop="dbroles">
            <transfer
              :data="dbRoleList"
              :target-keys="addPrivForm.dbRole"
              :list-style="listStyle"
              @on-change="addPrivDBRoleChange"
              filterable></transfer>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="addPrivSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="addPrivCancel">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>

    <Drawer
      :title="resetPasswordModalTitle"
      v-model="resetPasswordModal"
      width="500"
      :mask-closable="true"
      @on-close="resetPasswordCancel">
      <div>
        <Form ref="resetPasswordForm" :model="resetPasswordForm" :label-width="90"
                :rules="resetPasswordRuleValidate">
          <FormItem label="新密码" prop="password">
            <Input type="password" v-model="resetPasswordForm.password" placeholder=""></Input>
          </FormItem>
          <FormItem label="确认密码" prop="repassword">
            <Input type="password" v-model="resetPasswordForm.repassword" placeholder=""></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="resetPassword">提交</Button>
            <Button style="margin-left: 8px" @click="resetPasswordCancel">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>

    <Drawer
      :title="revokePrivModalTitle"
      v-model="revokePrivModal"
      width="1024"
      :mask-closable="true"
      @on-close="revokePrivCancel">
      <div>
        <Form ref="revokePrivForm" :model="revokePrivForm" :label-width="80">
          <FormItem label="服务器角色" prop="serverRoles">
            <transfer
              :data="userServerRoleList"
              :target-keys="revokePrivForm.serverRoles"
              :list-style="listStyle"
              @on-change="userServerRoleChange"
              filterable></transfer>
          </FormItem>
          <FormItem label="数据库角色" prop="dbroles">
            <transfer
              :data="userDBRoleList"
              :target-keys="revokePrivForm.dbRoles"
              :list-style="listStyle"
              @on-change="userDBRoleChange"
              filterable></transfer>
          </FormItem>
          <FormItem label="权限" prop="privileges">
            <transfer
              :data="userPrivList"
              :target-keys="revokePrivForm.privileges"
              :list-style="listStyle"
              @on-change="userPrivChange"
              filterable></transfer>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="revokePrivilege">提交</Button>
            <Button style="margin-left: 8px" @click="revokePrivCancel">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>

    <Drawer
      :title="addUserModalTitle"
      v-model="addUserModal"
      width="1024"
      :mask-closable="true"
      @on-close="addUserCancel">
      <div>
        <Form ref="addUserForm" :model="addUserForm" :label-width="100"
                :rules="addUserRuleValidate">
          <FormItem label="账户名" prop="name">
            <Input v-model="addUserForm.name" placeholder=""></Input>
          </FormItem>
          <FormItem label="密码" prop="password">
            <Input type="password" v-model="addUserForm.password" placeholder="大写、小写、数字、特殊字符至少各一位，长度8位以上"></Input>
          </FormItem>
          <FormItem label="确认密码" prop="repassword">
            <Input type="password" v-model="addUserForm.repassword" placeholder=""></Input>
          </FormItem>
          <FormItem label="密码策略" prop="passwordPolicy">
            <Checkbox v-model="addUserForm.passwordPolicy" label=1 @on-change="passwordPolicyChange()">强制密码策略</Checkbox>
            <Checkbox v-model="addUserForm.passwordExpire" label=1 @on-change="passwordExpireChange()">强制密码过期</Checkbox>
          </FormItem>
          <FormItem label="默认数据库" prop="defaultDB">
            <Select v-model="addUserForm.defaultDB" @on-change="getSchema"  filterable clearable>
              <Option v-for="item in databaseList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="架构" prop="schema">
            <Select v-model="addUserForm.schema" filterable clearable>
              <Option v-for="item in schemaList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="服务器角色列表" prop="serverRole">
            <transfer
              :data="serverRoleList"
              :target-keys="addUserForm.serverRole"
              :list-style="listStyle"
              @on-change="addUserServerRoleChange"
              filterable></transfer>
          </FormItem>
          <FormItem label="数据库角色列表" prop="dbRole">
            <transfer
              :data="dbRoleList"
              :target-keys="addUserForm.dbRole"
              :list-style="listStyle"
              @on-change="addUserDBRoleChange"
              filterable></transfer>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="addUserSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="addUserCancel">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>

    <Card>
      <Row>
        <i-col span="21">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
        <i-col span="3">
          <Button style="float: right;" @click="refresh()" type="primary" :style="{marginBottom: '10px'}" icon="md-refresh">刷新</Button>
        </i-col>
      </Row>
      <Divider />
      <Row>
        <Col span="24" :md="18">
          <Form ref="searchForm" inline :model="searchForm" onsubmit="return false;">
            <FormItem prop="name">
              <i-input clearable placeholder="用户名" v-model="searchForm.name" style="min-width: 200px;" search
                        @on-enter="getInstanceUser()"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getInstanceUser()">搜索</Button>
              <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="6" class="align-right">
          <Button style="float: right;" @click="addUser()" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加用户
          </Button>
        </Col>
      </Row>
      <tables ref="instanceUserTable" editable height="600" search-place="top" v-model="instanceUserData"
              :columns="userColumns" @on-save-edit="editUser" class="mob-remove-table-fixed"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getInstanceUser"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {
  getInstanceUserList,
  resetUserPassword,
  deleteInstanceUser,
  getPrivList,
  getDBRoleList,
  getServerRoleList,
  showDatabaseList,
  revokePrivilege,
  editLoginUser,
  getServerRole,
  getDBRole,
  createUser,
  getDBSchema,
  addUserPrivs
} from '@/api/sqlserver'

export default {
  name: 'sqlserverInstanceUser',
  components: {
    Tables
  },
  data: function () {
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认输入密码'))
      } else if (value !== this.resetPasswordForm.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }

    const validateUserPassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认输入密码'))
      } else if (value !== this.addUserForm.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }

    return {
      searchForm: {
        name: ''
      },
      listStyle: {
        width: '400px',
        height: '300px'
      },
      // 回收权限
      revokePrivModal: false,
      revokePrivModalTitle: '权限回收',
      revokePrivForm: {
        serverRoles: [],
        dbRoles: [],
        privileges: []
      },
      userDBRoleList: [],
      userServerRoleList: [],
      userPrivList: [],
      databaseList: [],

      // 重置密码
      resetPasswordModal: false,
      resetUser: null,
      resetPasswordModalTitle: '重置密码',
      resetPasswordForm: {
        password: '',
        repassword: ''
      },
      resetPasswordRuleValidate: {
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur'},
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        repassword: [{validator: validatePassCheck, trigger: 'blur'}]
      },
      count: 1,
      size: 15,
      page: 1,
      is_superuser: false,
      userColumns: [
        {title: '登录名', key: 'user', align: 'center', fixed: 'left', width: 200},
        {title: '身份认证', key: 'type_desc', align: 'center', minWidth: 150},
        {
          title: '连接',
          key: 'denylogin',
          align: 'center',
          minWidth: 160,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '允许'}, {value: 1, label: '拒绝'}]
        },
        {
          title: '登录',
          key: 'is_disabled',
          align: 'center',
          minWidth: 140,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '是'}, {value: 1, label: '否'}]
        },
        {
          title: '默认数据库',
          key: 'default_database_name',
          align: 'center',
          minWidth: 180,
          editable: true,
          editType: 'select',
          selectItem: []
        },
        {title: '默认语言', key: 'language', align: 'center', minWidth: 120},
        {title: '创建时间', key: 'createdate', align: 'center', minWidth: 200},
        {
          title: 'IsSysAdmin',
          key: 'sysadmin',
          align: 'center',
          minWidth: 130,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '否'}, {value: 1, label: '是'}]
        },
        {
          title: 'IsSecurityAdmin',
          key: 'securityadmin',
          align: 'center',
          minWidth: 160,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '否'}, {value: 1, label: '是'}]
        },
        {
          title: 'IsServerAdmin',
          key: 'serveradmin',
          align: 'center',
          minWidth: 150,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '否'}, {value: 1, label: '是'}]
        },
        {
          title: 'IsSetupAdmin',
          key: 'setupadmin',
          align: 'center',
          minWidth: 130,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '否'}, {value: 1, label: '是'}]
        },
        {
          title: 'IsProcessAdmin',
          key: 'processadmin',
          align: 'center',
          minWidth: 150,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '否'}, {value: 1, label: '是'}]
        },
        {
          title: 'IsDiskAdmin',
          key: 'diskadmin',
          align: 'center',
          minWidth: 130,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '否'}, {value: 1, label: '是'}]
        },
        {
          title: 'IsDbCreator',
          key: 'dbcreator',
          align: 'center',
          minWidth: 130,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '否'}, {value: 1, label: '是'}]
        },
        {
          title: 'IsBulkAdmin',
          key: 'bulkadmin',
          align: 'center',
          minWidth: 130,
          editable: true,
          editType: 'select',
          selectItem: [{value: 0, label: '否'}, {value: 1, label: '是'}]
        },
        {
          title: '操作',
          // align: 'center',
          fixed: 'right',
          width: 300,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.resetUser = params.row.user
                      this.addPrivilege()
                    }
                  }
                }, [
                  h('div', '添加权限')
                ]),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                    // shape: 'circle'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.resetUser = params.row.user
                      this.resetPasswordModal = true
                    }
                  }
                }, [
                  h('div', '重置密码')
                ]),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                    // shape: 'circle'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let data = {
                        id: this.$route.query.id,
                        user: params.row.user
                      }
                      this.resetUser = params.row.user
                      this.getPrivs(data)
                      this.getDBRoles(data)
                      this.getServerRoles(data)
                      this.revokePrivModal = true
                    }
                  }
                }, [
                  h('div', '权限回收')
                ]),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleDelete(params.row.user)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                      // shape: 'circle'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, [
                    h('div', '删除')
                  ])
                ])

              ])
            }
          }
        }
      ],
      instanceUserData: [],

      // 添加权限
      addPrivModalTitle: '添加权限',
      addPrivModal: false,
      addPrivForm: {
        id: this.$route.query.id,
        name: '',
        serverRole: [],
        dbRole: []
      },
      // 添加用户
      addUserModalTitle: '创建账号',
      addUserModal: false,
      serverRoleList: [],
      dbRoleList: [],
      schemaList: [],
      addUserForm: {
        id: this.$route.query.id,
        name: '',
        password: '',
        defaultDB: 'master',
        schema: 'dbo',
        passwordPolicy: '',
        passwordExpire: '',
        serverRole: [],
        dbRole: []
      },
      addUserRuleValidate: {
        name: [{required: true, message: '请输入数据库账户', trigger: 'blur'}],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur'},
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        repassword: [{validator: validateUserPassCheck, trigger: 'blur'}]
      }
    }
  },
  methods: {
    initColumn () {
      this.userColumns[4].selectItem = this.databaseList
    },
    searchReset () {
      this.searchForm.name = ''
      this.getInstanceUser()
    },
    refresh () {
      this.getInstanceUser()
    },
    getInstanceUser (value = 1) {
      this.page = value
      let params = {
        id: this.$route.query.id,
        page: this.page,
        size: this.size,
        ordering: this.ordering,
        name: this.searchForm.name
      }
      getInstanceUserList(params).then(res => {
        this.instanceUserData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取用户列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取用户列表失败！服务器无响应'
          })
        }
      })
    },
    resetPasswordCancel () {
      this.resetPasswordForm.password = ''
      this.resetPasswordForm.repassword = ''
      this.resetPasswordModal = false
    },
    resetPassword () {
      this.$refs['resetPasswordForm'].validate((valid) => {
        if (valid) {
          let data = {
            id: this.$route.query.id,
            user: this.resetUser,
            password: this.resetPasswordForm.password
          }
          resetUserPassword(data).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getInstanceUser()
            this.resetPasswordCancel()
            this.resetPasswordModal = false
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    handleDelete (user) {
      let data = {
        id: this.$route.query.id,
        user: user
      }
      deleteInstanceUser(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getInstanceUser()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    getPrivs (data) {
      let that = this
      that.userPrivList = []
      getPrivList(data).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.userPrivList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },
    getDBRoles (data) {
      let that = this
      that.userDBRoleList = []
      getDBRoleList(data).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.userDBRoleList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },
    getServerRoles (data) {
      let that = this
      that.userServerRoleList = []
      getServerRoleList(data).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.userServerRoleList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },
    userPrivChange (newTargetKeys) {
      this.revokePrivForm.privileges = newTargetKeys
    },
    userDBRoleChange (newTargetKeys) {
      this.revokePrivForm.dbRoles = newTargetKeys
    },
    userServerRoleChange (newTargetKeys) {
      this.revokePrivForm.serverRoles = newTargetKeys
    },

    revokePrivCancel () {
      this.revokePrivForm.privileges = []
      this.revokePrivForm.dbRoles = []
      this.revokePrivForm.serverRoles = []
      this.revokePrivModal = false
    },
    revokePrivilege () {
      this.$refs['revokePrivForm'].validate((valid) => {
        if (valid) {
          if (this.revokePrivForm.dbRoles.length !== 0 || this.revokePrivForm.serverRoles.length !== 0 || this.revokePrivForm.privileges.length !== 0) {
            let data = {
              id: this.$route.query.id,
              user: this.resetUser,
              roles: this.revokePrivForm.dbRoles,
              privileges: this.revokePrivForm.privileges,
              server_roles: this.revokePrivForm.serverRoles
            }
            revokePrivilege(data).then(res => {
              this.$Notice.success({title: '操作成功！'})
              this.getInstanceUser()
              this.revokePrivCancel()
            }).catch(res => {
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          } else {
            this.$Notice.error({
              title: '请至少选择一种权限'
            })
          }
        }
      })
    },
    editUser (params) {
      let data = {
        id: this.$route.query.id,
        user: params.row.user,
        field: params.column.key,
        value: params.value
      }
      editLoginUser(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
      this.getInstanceUser()
    },
    getDatabases () {
      let params = {
        id: this.$route.query.id
      }
      showDatabaseList(params).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            this.databaseList.push({
              value: result[i],
              label: result[i]
            })
          }
        }
      })
    },

    getServerRoleList () {
      let that = this
      that.serverRoleList = []
      let params = {
        id: this.$route.query.id
      }
      getServerRole(params).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.serverRoleList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },

    getDBRoleList () {
      let that = this
      that.dbRoleList = []
      let params = {
        id: this.$route.query.id
      }
      getDBRole(params).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.dbRoleList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },

    getSchema (db) {
      this.schemaList = []
      let data = {
        id: this.$route.query.id,
        db: db
      }
      getDBSchema(data).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            this.schemaList.push({
              value: result[i],
              label: result[i]
            })
          }
        }
      })
    },

    initSchema (db) {
      this.schemaList = []
      let data = {
        id: this.$route.query.id,
        db: db
      }
      getDBSchema(data).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            this.schemaList.push({
              value: result[i],
              label: result[i]
            })
          }
        }
      })
    },

    addUser () {
      this.getServerRoleList()
      this.getDBRoleList()
      this.initSchema(this.addUserForm.defaultDB)
      this.addUserModal = true
    },

    addUserServerRoleChange (newTargetKeys) {
      this.addUserForm.serverRole = newTargetKeys
    },
    addUserDBRoleChange (newTargetKeys) {
      this.addUserForm.dbRole = newTargetKeys
    },

    addUserCancel () {
      this.addUserForm.name = ''
      this.addUserForm.password = ''
      this.addUserForm.repassword = ''
      this.addUserForm.passwordPolicy = false
      this.addUserForm.passwordExpire = false
      this.addUserForm.defaultDB = 'master'
      this.addUserForm.schema = 'dbo'
      this.addUserForm.serverRole = []
      this.addUserForm.dbRole = []
      this.addUserModal = false
    },

    passwordExpireChange () {
      if (this.addUserForm.passwordExpire) {
        this.addUserForm.passwordPolicy = true
      }
    },

    passwordPolicyChange () {
      if (!this.addUserForm.passwordPolicy) {
        this.addUserForm.passwordExpire = false
      }
    },

    addUserSubmit () {
      this.$refs['addUserForm'].validate((valid) => {
        if (valid) {
          createUser(this.addUserForm).then(res => {
            this.$Notice.success({title: '操作成功！'})
            this.getInstanceUser()
            this.addUserCancel()
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        }
      })
    },

    addPrivilege () {
      this.getServerRoleList()
      this.getDBRoleList()
      this.addPrivModal = true
    },

    addPrivServerRoleChange (newTargetKeys) {
      this.addPrivForm.serverRole = newTargetKeys
    },
    addPrivDBRoleChange (newTargetKeys) {
      this.addPrivForm.dbRole = newTargetKeys
    },

    addPrivCancel () {
      this.addPrivForm.name = ''
      this.addPrivForm.serverRole = []
      this.addPrivForm.dbRole = []
      this.addPrivModal = false
    },
    addPrivSubmit () {
      this.$refs['addPrivForm'].validate((valid) => {
        if (valid) {
          if (this.addPrivForm.dbRole.length !== 0 || this.addPrivForm.serverRole.length !== 0) {
            this.addPrivForm.name = this.resetUser
            addUserPrivs(this.addPrivForm).then(res => {
              this.$Notice.success({title: '操作成功！'})
              this.getInstanceUser()
              this.addPrivCancel()
            }).catch(res => {
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          } else {
            this.$Notice.error({
              title: '请至少选择一种权限'
            })
          }
        }
      })
    }

  },
  mounted: function () {
    this.getDatabases()
    this.initColumn()
    this.getInstanceUser()
  }
}
</script>
<style lang="less">
  @media screen and (max-width:640px) {
    .sql-instanceUser-page {
      h1 {
        font-size: 1.5em;
      }
      .ivu-divider-horizontal{
        margin:10px 0 15px;
      }
      .tables-edit-outer .tables-edit-con .tables-edit-btn{
        display: block!important;
      }
    }
  }
</style>
